<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <PermissionForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import PermissionForm from '@/components/settings/users/permission/PermissionForm'

export default {
  name: 'PermissionAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    PermissionForm
  }
}
</script>
